import type { SpaceGroupWithSpaces } from "@circle-react/components/Spaces/Sidebar/index";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { BottomButton } from "./BottomButton";
import Space from "./Space";
import { SpaceListView } from "./SpaceListView";

export interface SpaceListProps {
  spaceGroup: SpaceGroupWithSpaces;
}

export const SpaceList = ({ spaceGroup }: SpaceListProps) => {
  const { spaces } = spaceGroup;
  const hasSpaces = spaces.length > 0;

  if (!hasSpaces) {
    return <BottomButton spaceGroup={spaceGroup} />;
  }

  return (
    <SortableContext
      items={spaces.map(space => `space-${space.id}`)}
      strategy={verticalListSortingStrategy}
    >
      <SpaceListView>
        {spaces.map(space => (
          <Space key={space.id} space={space} />
        ))}
      </SpaceListView>
    </SortableContext>
  );
};

SpaceList.displayName = "SpaceList";
